import { useRequireAuth } from './useRequireAuth';
import { useAuth } from './useAuth';

export const useRequireUser = () => {
  const { isAuthenticated } = useRequireAuth();
  const { user, userLoading, userLoaded } = useAuth();

  return { 
    user, 
    userLoading, 
    userLoaded,
    isReady: isAuthenticated && userLoaded 
  };
};